import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";

import useTheme from "hooks/useTheme";

import { HiOutlineTranslate } from "react-icons/hi";
import { BsCurrencyExchange } from "react-icons/bs";
import { IoColorPaletteOutline } from "react-icons/io5";
import { BiBell } from "react-icons/bi";
import { FaUserLock } from "react-icons/fa";

import Language from "views/components/settings/Language";
import Theme from "views/components/settings/Theme";
import BaseCurrency from "views/components/settings/BaseCurrency";
import Notifications from "views/components/settings/Notifications";
import Security from "views/components/settings/Security";
import FollowUsLandingPage from "views/components/partials/FollowUsLandingPage";
import SelectedDotIcon from "theme/icons/SelectedDot";

const Settings = () => {
	const { themeColor, appLanguage } = useTheme();

	const [activeSettingsItem, setActiveSettingsItem] = useState(null);

	const menuListIconStyle = `text-2xl ${themeColor?.text}`;

	const SettingsList = [
		{
			title: appLanguage?.selectLanguage,
			icon: <HiOutlineTranslate className={menuListIconStyle} />,
			link: "Theme",
		},
		{
			title: appLanguage?.selectTheme,
			icon: <IoColorPaletteOutline className={menuListIconStyle} />,
			link: "Theme",
		},
		{
			title: appLanguage?.selectBaseCurrency,
			icon: <BsCurrencyExchange className={menuListIconStyle} />,
			link: "Theme",
		},
		{
			title: appLanguage?.myNotifications,
			icon: <BiBell className={menuListIconStyle} />,
			link: "Theme",
		},
		{
			title: appLanguage?.securityOptions,
			icon: <FaUserLock className={menuListIconStyle} />,
			link: "Theme",
		},
	];

	const SwitchSettingsItemPage = (activeSettingsItem) => {
		switch (activeSettingsItem) {
			case 1:
				return <Language />;
			case 2:
				return <Theme />;
			case 3:
				return <BaseCurrency />;
			case 4:
				return <Notifications />;
			case 5:
				return <Security />;
			default:
				return null;
		}
	};

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="w-full flex">
				<div className="items-center justify-content w-[50%] flex-col px-5 space-y-2">
					<div className={`flex items-center w-full space-x-4`}>
						<h1 className={`w-full text-xl font-bold ${themeColor?.text} pb-1`}>{appLanguage?.settings}</h1>
					</div>
					{SettingsList.map((listItem, index) => (
						<div
							className={`flex w-full items-center justify-start space-x-4 cursor-pointer bg-opacity-10 py-4 px-3 rounded-xl ${
								activeSettingsItem === index + 1 && themeColor?.bg
							}`}
							onClick={() => setActiveSettingsItem(index + 1)}
							key={index}
						>
							{listItem?.icon}
							<p className={`w-full text-sm font-bold ${themeColor?.text}`}>{listItem?.title}</p>
							{activeSettingsItem === index + 1 && <SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />}
						</div>
					))}
				</div>

				{activeSettingsItem ? SwitchSettingsItemPage(activeSettingsItem) : <FollowUsLandingPage />}
			</div>
		</Transition>
	);
};

export default Settings;
